import { SystemStyleObject } from "@chakra-ui/styled-system";

export const FundFamilyUseAllocationTableTheme: SystemStyleObject = {
  "&.ag-theme-maybern": {
    "--ag-row-height": "40px",
    height: "100%",
    ".ag-cell": {
      alignItems: "center",
    },
    ".ag-cell.ag-cell-focus:not(.ag-cell-range-selected)": {
      '&[col-id="addRemove"], &[col-id="is_auto_allocate"]': {
        borderTopColor: "transparent",
        borderRightColor: "var(--ag-border-color)",
        borderBottomColor: "transparent",
        borderLeftColor: "transparent",
        bg: "transparent !important",
      },
    },
    '.ag-cell[col-id="spacer"].ag-cell-focus': {
      bg: "transparent",
    },
    ".ag-header-group-cell": {
      justifyContent: "center",
    },
    ".ag-header-cell .ag-cell-label-container": {
      pb: 0,
    },
    ".ag-cell, .ag-header-cell": {
      "&:not(.ag-cell-focus), &.ag-cell-focus:not(:focus-within)": {
        "&:not([col-id='spacer'])": {
          borderRightWidth: "1px",
          borderRightColor: "var(--ag-border-color)",
        },
      },
    },
    "&.mb-use-allocation-has-categories": {
      '.ag-header-cell[col-id="addRemove"]': {
        display: "none",
      },
      '.ag-header-cell[aria-colindex="2"]': {
        overflow: "visible",
        ".ag-header-cell-comp-wrapper": {
          marginLeft: "-86px",
        },
      },
    },
    ".ag-row.ag-row-footer .ag-cell:not(.ag-column-first)": {
      justifyContent: "flex-end",
    },
    ".ag-row.mb-row-is-total .ag-cell:not(.ag-column-first)": {
      justifyContent: "flex-end",
    },
    ".ag-header-group-cell.mb-use-allocation-header-inputs": {
      bg: "eggplant.25",
      "--ag-header-cell-hover-background-color":
        "var(--chakra-colors-eggplant-25)",
    },
    ".ag-header-cell-comp-wrapper": {
      whiteSpace: "normal",
    },
    [[
      ".ag-header-cell.mb-header-in-group:not(.mb-header-last-in-group)",
      ".ag-cell.mb-cell-in-group:not(.mb-cell-last-in-group):not(:focus-within.ag-cell-focus):not(.mb-cell-is-total-label)",
    ].join(", ")]: {
      borderRightColor: "transparent",
    },
    ".ag-header-group-cell-no-group": {
      "--ag-border-color": "transparent",
    },
  },
};
